export default __webpack_public_path__ + "static/media/mailIcon.7a44a81c.svg";